/**
 * Please insert in alphabetical order.
 * It helps find things more easily. If you see
 * something out of place, please fix it.
 */
const permissions = {
	ESS_DIAGNOSTICS: "ESSdiagnostics",
	ESS_VIEW: "ESSview",
	ESS_OPERATIONS: "ESSoperations",
	HELP_VIEW: "HELPview",
	MOT_VIEW: "MOTview",
	MOT_APPROVE: "MOTapprove",
	MOT_EDIT: "MOTedit",
	MPD_ANALYSIS_TAB: "MPDanalysistab",
	MPD_REPORTS_TAB: "MPDreportstab",
	MPD_VEHICLE_TAB: "MPDvehicletab",
	MPD_FORM_TAB: "MPDformstab",
	RSU_LAB_TEST: "RSUlabtest",
	RSU_MAP_ACTIVATE: "RSUMAPactivate",
	RSU_MAP_EDIT: "RSUMAPedit",
	RSU_MAP_VIEW: "RSUMAPview",
	RSU_NEAR_NEIGHBOR: "RSUnearneighbor",
	RSU_OPERATIONS: "RSUoperations",
	RSU_ON_DEMANDCHECK: "RSUondemand",
	RSU_TIM_ACTIVATE: "RSUTIMactivate",
	RSU_TIM_EDIT: "RSUTIMedit",
	RSU_TIM_VIEW: "RSUTIMview",
	RSU_RWM_ACTIVATE: "RSURWMactivate",
	RSU_RWM_EDIT: "RSURWMedit",
	RSU_RWM_VIEW: "RSURWMview",
	RSU_VIEW: "RSUview",
	RSU_VU_FEED_VIEW: "RSUvufeedview",
	RSU_VU_TEST_VIEW: "RSUvutestview",
	SCR_ESS_APPROVE: "SCRESSapprove",
	SCR_ESS_EDIT: "SCRESSedit",
	SCR_ESS_VIEW: "SCRESSview",
	SCR_RSU_APPROVE: "SCRRSUapprove",
	SCR_RSU_EDIT: "SCRRSUedit",
	SCR_RSU_VIEW: "SCRRSUview",
	SCR_TS_APPROVE: "SCRTSapprove",
	SCR_TS_EDIT: "SCRTSedit",
	SCR_TS_VIEW: "SCRTSview",
	SCR_TSC_APPROVE: "SCRTSCapprove",
	SCR_TSC_EDIT: "SCRTSCedit",
	SCR_TSC_VIEW: "SCRTSCview",
	SCR_VIEW: "SCRview",
	SPAT_VERIFY_VIEW: "SPATVERIFYview",
	SYS_ADMIN_HEALTH_CHECK_VIEW: "SYSADMINhealthcheckview",
	TFM_VIEW: "TFMview",
	TFR_EDIT: "TFRcreate",
	TFR_VIEW: "TFRview",
	TOTAL_STATION_VIEW: "TOTALSTATIONview",
	TOTALSTATION_SCR_VIEW: "SCRTSview",
	TSC_VIEW: "TSCview",
	USER_SETUP_VIEW: "USERSETUPview",
	USER_SETUP_MODIFY_ALL_CLIENT: "USERSETUPmodifyallclient",
	USER_SETUP_MODIFY_IN_CLIENT: "USERSETUPmodifyinclient",
	VIDAS_CONFIG_VIEW: "VIDASCONFIGview",
	WP_VIEW: "TFRwpview",
	WP_EDIT: "TFRwpedit"
};

export default permissions;
